export default __webpack_public_path__ + "static/media/1579.033120e8.png";